import { render, staticRenderFns } from "./personSd.vue?vue&type=template&id=7770b9c4&scoped=true&"
import script from "./personSd.vue?vue&type=script&lang=js&"
export * from "./personSd.vue?vue&type=script&lang=js&"
import style0 from "./personSd.vue?vue&type=style&index=0&id=7770b9c4&prod&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7770b9c4",
  null
  
)

export default component.exports